module.exports = __webpack_public_path__ + "img/background.6365eb10.png";